import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DialogModule } from '@features/dialog/dialog.module';
import { ProductMiniModule } from '@features/product-mini/product-mini.module';
import { StoreStockContainerComponent } from '@features/store-stock/store-stock-container/store-stock-container.component';
import { StoreMatches } from '@features/store-stock/store-stock-pipes/store-matches.pipe';
import { StoreStock } from '@features/store-stock/store-stock-pipes/store-stock.pipe';
import { StoresWithStock } from '@features/store-stock/store-stock-pipes/stores-with-stock.pipe';
import { StoresOverviewModule } from '@features/stores-overview/stores-overview.module';
import { FormElementsModule } from '@shared/form-elements/form-elements.module';
import { SharedModule } from '@shared/shared.module';

import { ReserveInStoreComponent } from '@features/store-stock/reserve-in-store/reserve-in-store.component';

import { StoreStockListItemComponent } from './store-stock-list-item/store-stock-list-item.component';
import { StoreStockListComponent } from './store-stock-list/store-stock-list.component';
import { FilterStoresByFlagPipe } from './store-stock-pipes/filter-stores-by-flag.pipe';
import { StoreStockStatusPipe } from './store-stock-pipes/store-stock-status.pipe';
import { StoreStockDetailedComponent } from './store-stock-detailed/store-stock-detailed.component';
import { ReserveInStoreModule } from '@features/reserve-in-store/reserve-in-store.module';
import { SortFavoriteStorePipe } from './store-stock-pipes/sort-favorite-store.pipe';
import { StoreStockStatusTranslationPipe } from './store-stock-pipes/store-stock-status-translation.pipe';
import { StockMessageComponent } from './stock-message/stock-message.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        RouterModule,
        FormElementsModule,
        DialogModule,
        StoresOverviewModule,
        ProductMiniModule,
        ReserveInStoreModule,
        StoreStockContainerComponent,
        StoreStockListItemComponent,
        StoreStock,
        StoreMatches,
        StoresWithStock,
        StoreStockListComponent,
        FilterStoresByFlagPipe,
        StoreStockStatusPipe,
        StoreStockDetailedComponent,
        ReserveInStoreComponent,
        SortFavoriteStorePipe,
        StoreStockStatusTranslationPipe,
        StockMessageComponent
    ],
    exports: [
        StoreStockContainerComponent,
        StoreStock,
        StoreMatches,
        StoresWithStock,
        StoreStockStatusPipe,
        StoreStockListItemComponent,
        StoreStockStatusTranslationPipe,
        StoreStockDetailedComponent
    ]
})
export class StoreStockModule {}
